/* eslint-disable angular/controller-name */

angular.
module("dx.webapp.masterTools").
controller("DxBulkUnifyPasswordRouteController", function BulkUnifyPasswordRouteController(
	$http,

	validationService,

	ngPasteFromErrors
) {
	"use strict";

	var self = this;

	self.emails = [];
	self.newPassword = "";
	self.error = null;
	self.isChangingPassword = false;
	self.hasChangedPassword = false;

	self.onBeforePaste = function onBeforePaste(data) {
		self.error = null;
		self.hasChangedPassword = false;
		self.newPassword = "";

		return data;
	};

	self.onValidateEntry = function onValidateEntry(row) {
		var isValid = validationService.isEmailValid(row.email.trim());
		if (!isValid) {
			self.error = "Current e-mail is not valid: " + row.email.trim();
		}
		return isValid;
	};

	self.onEntryError = function onEntryError(error, rowData) {
		if (error === ngPasteFromErrors.invalidColumnLength) {
			self.error = "Expected column length to be " + rowData.expectedLength;
		}
	};

	self.bulkUnifyPassword = function bulkUnifyPassword() {
		self.isChangingPassword = true;

		var emails = [];
		for (var i = 0; i < self.emails.length; i++) {
			emails.push(self.emails[i].email);
		}
		var url = "api/task/mastertools/password/unify";
		$http.post(url, {emails: emails, newPassword: self.newPassword}).then(onBulkUnifyPasswordSuccess, onBulkUnifyPasswordError);

		function onBulkUnifyPasswordSuccess(response) {
			if (response.status === 200) {
				self.error = null;
				self.isChangingPassword = false;
				self.hasChangedPassword = true;
			}
		}

		function onBulkUnifyPasswordError(response) {
			if (response.data.message !== null && response.data.message.length > 0) {
				self.error = response.data.message;
			}
			self.isChangingPassword = false;
		}
	};
});
